import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";  
import "react-toastify/dist/ReactToastify.css"; 


// User Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Wishlist from "./pages/Wishlist";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import MyOrders from "./pages/MyOrders";
import AboutUs from "./pages/AboutUs";
import SocialFloat from "./components/SocialFloat";
import EmiOptions from "./pages/EmiOptions";
import EmiForm from "./pages/EmiForm";
import EmiSuccess from "./pages/EmiSuccess";
import EmiDocuments from "./pages/EmiDocuments";













// Admin Pages
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProducts from "./pages/AdminProducts";
import AdminUsers from "./pages/AdminUsers";
import AdminOrders from "./pages/AdminOrders";
import AdminAddProduct from "./pages/AdminAddProduct";
import AdminBanner from "./pages/AdminBanner";
import EditProduct from "./pages/EditProduct";
import AdminMandates from "./pages/AdminMandates";
 import AdminEMIRequestDetail from "./pages/AdminEMIRequestDetail"; 
import AdminEMIRequests from "./pages/AdminEMIRequests";
import PermissionEditor from "./pages/PermissionEditor";
import ManageAdmins from "./pages/ManageAdmins";
import AddAdmin from "./pages/AddAdmin";
import PermissionsPanel from "./pages/PermissionsPanel";




// Shared Components
import NavBar from "./components/NavBar";

// App wrapper that manages route-based logic
function AppWrapper() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  const [user, setUser] = useState(() => {
    if (!isAdminRoute) {
      const savedUser = localStorage.getItem("user");
      return savedUser ? JSON.parse(savedUser) : null;
    }
    return null;
  });

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/";
  };

  useEffect(() => {
    if (isAdminRoute && localStorage.getItem("user")) {
      alert("You are logged in as a user. Please logout to access admin panel.");
      window.location.href = "/";
    }
  }, [location]);

  return (
    <>
      {/* Only show NavBar on non-admin routes */}
      {!isAdminRoute && <NavBar user={user} onLogout={logout} />}

      <main style={{ padding: "20px" }}>
        <Routes>
          {/* User Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/emi-options" element={<EmiOptions />} />
          <Route path="/emi-form" element={<EmiForm />} />
          <Route path="/emi-success" element={<EmiSuccess />} />
          <Route path="/emi-documents" element={<EmiDocuments />} />



          {/* Admin Pages */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/products/add" element={<AdminAddProduct />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/banners" element={<AdminBanner />} />
          <Route path="/admin/products/edit/:id" element={<EditProduct />} />
          <Route path="/admin/mandates" element={<AdminMandates />} />
         <Route path="/admin/emi-requests" element={<AdminEMIRequests />} />
          <Route path="/admin/emi-request/:emi_id" element={<AdminEMIRequestDetail />} />
          <Route path="/admin/manage-users" element={<ManageAdmins />} />
<Route path="/admin/manage-users/:admin_id" element={<PermissionEditor />} />
<Route path="/admin/add-admin" element={<AddAdmin />} />
<Route path="/admin/permissions" element={<PermissionsPanel />} />


          

        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <>
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
    <SocialFloat />
    <ToastContainer position="top-right" autoClose={5000} />
    </>

  );
}

export default App;
